<div class="container">
  <div class="manager-Details">
    <div class="detail-header">
      <span class="material-icons">contact_phone</span>
      <span class="detail-title">{{
        'contactus.contactdet' | cxTranslate
      }}</span>
    </div>
    <hr />
    <div class="details-body">
      <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group col">
            <label>
              <span class="required">*</span>
              {{ 'contactus.firstname' | cxTranslate }}</label
            >
            <input
              type="text"
              formControlName="firstName"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['firstName'].touched) && f['firstName'].errors
              }"
            />
            <div
              *ngIf="
                (submitted || f['firstName'].touched) && f['firstName'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f['firstName'].errors?.required">
                {{ 'contactus.firstnameerror' | cxTranslate }}
              </div>
            </div>
          </div>
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.lastname' | cxTranslate }}</label
            >
            <input
              type="text"
              formControlName="lastName"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['lastName'].touched) && f['lastName'].errors
              }"
            />
            <div
              *ngIf="
                (submitted || f['lastName'].touched) && f['lastName'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.lastName.errors?.required">
                {{ 'contactus.lastnameerror' | cxTranslate }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.companyname' | cxTranslate }}</label
            >
            <input
              type="text"
              formControlName="companyName"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['companyName'].touched) &&
                  f['companyName'].errors
              }"
            />
            <div
              *ngIf="
                (submitted || f['companyName'].touched) &&
                f['companyName'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.companyName.errors?.required">
                {{ 'contactus.companynameerror' | cxTranslate }}
              </div>
            </div>
          </div>
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.jobrole' | cxTranslate }}
            </label>
            <select
              formControlName="jobRoleCode"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['jobRoleCode'].touched) &&
                  f['jobRoleCode'].errors
              }"
            >
              <option value="">
                {{ 'contactus.jobselect' | cxTranslate }}
              </option>
              <option
                *ngFor="let entity of contactFormData.jobRoleCode"
                [ngValue]="entity.code"
              >
                {{ entity.name }}
              </option>
            </select>
            <div
              *ngIf="
                (submitted || f['jobRoleCode'].touched) &&
                f['jobRoleCode'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.jobRoleCode.errors?.required">
                {{ 'contactus.jobroleerror' | cxTranslate }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.email' | cxTranslate }}</label
            >
            <input
              type="text"
              formControlName="companyEmailAddress"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['companyEmailAddress'].touched) &&
                  f['companyEmailAddress'].errors
              }"
            />
            <div
              *ngIf="
                (submitted || f['companyEmailAddress'].touched) &&
                f['companyEmailAddress'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.companyEmailAddress.errors.required">
                {{ 'contactus.companyemail' | cxTranslate }}
              </div>
              <div *ngIf="f.companyEmailAddress.errors.pattern">
                {{ 'contactus.invalidemail' | cxTranslate }}
              </div>
            </div>
          </div>
          <div class="form-group col">
            <label
              ><span class="required">*</span
              >{{ 'contactus.phonenum' | cxTranslate }}
            </label>
            <input
              type="text"
              formControlName="primaryPhoneNumber"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['primaryPhoneNumber'].touched) &&
                  f['primaryPhoneNumber'].errors
              }"
            />
            <div
              *ngIf="
                (submitted || f['primaryPhoneNumber'].touched) &&
                f['primaryPhoneNumber'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.primaryPhoneNumber.errors.required">
                {{ 'contactus.phonenumerror' | cxTranslate }}
              </div>
              <div *ngIf="f.primaryPhoneNumber.errors.pattern">
                {{ 'contactus.phonenumvalid' | cxTranslate }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.country' | cxTranslate }}
            </label>
            <select
              formControlName="countryCode"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['countryCode'].touched) &&
                  f['countryCode'].errors
              }"
            >
              <option value="">
                {{ 'contactus.selectcountry' | cxTranslate }}
              </option>

              <option
                *ngFor="let entity of contactFormData.countryCode"
                [ngValue]="entity.isocode"
              >
                {{ entity.name }}
              </option>
            </select>
            <div
              *ngIf="
                (submitted || f['countryCode'].touched) &&
                f['countryCode'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.countryCode.errors.required">
                {{ 'contactus.countryregion' | cxTranslate }}
              </div>
            </div>
          </div>
          <div class="form-group col">
            <label
              ><span class="required">*</span
              >{{ 'contactus.city' | cxTranslate }}
            </label>
            <input
              type="text"
              formControlName="city"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['city'].touched) && f['city'].errors
              }"
            />
            <div
              *ngIf="(submitted || f['city'].touched) && f['city'].errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.city.errors.required">
                {{ 'contactus.cityrequired' | cxTranslate }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col">
            <label
              ><span class="required">*</span
              >{{ 'contactus.postalcode' | cxTranslate }}
            </label>
            <input
              type="text"
              formControlName="postalCode"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['postalCode'].touched) &&
                  f['postalCode'].errors
              }"
            />
            <div
              *ngIf="
                (submitted || f['postalCode'].touched) && f['postalCode'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.postalCode.errors.required">
                {{ 'contactus.postalcodeerror' | cxTranslate }}
              </div>
              <div *ngIf="f.postalCode.errors.pattern">
                {{ 'contactus.zipcode' | cxTranslate }}
              </div>
            </div>
          </div>
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.areaofinterest' | cxTranslate }}
            </label>
            <select
              formControlName="areaOfInterestCode"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['areaOfInterestCode'].touched) &&
                  f['areaOfInterestCode'].errors
              }"
            >
              <option value="">
                {{ 'contactus.selectarea' | cxTranslate }}
              </option>
              <option
                *ngFor="let entity of contactFormData.areaOfInterestCode"
                [ngValue]="entity.code"
              >
                {{ entity.name }}
              </option>
            </select>
            <div
              *ngIf="
                (submitted || f['areaOfInterestCode'].touched) &&
                f['areaOfInterestCode'].errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.areaOfInterestCode.errors.required">
                {{ 'contactus.areareuired' | cxTranslate }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label
              ><span class="required">*</span>
              {{ 'contactus.providedet' | cxTranslate }}
            </label>
            <textarea
              type="text"
              formControlName="comment"
              class="form-control"
              maxlength="500"
              [ngClass]="{
                'is-invalid':
                  (submitted || f['comment'].touched) && f['comment'].errors
              }"
            ></textarea>
            <label class="charleft">
              {{ 'contactus.charctleft' | cxTranslate }}
              {{ maxChars - f['comment'].value?.length }}</label
            >
            <div
              *ngIf="(submitted || f['comment'].touched) && f['comment'].errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.comment.errors?.required">
                {{ 'contactus.requestreuired' | cxTranslate }}
              </div>
              <div *ngIf="f.comment.errors.maxlength">
                {{ 'contactus.reachedcontact' | cxTranslate }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <button role="button" class="submit-btn" type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
